import { useRef } from 'react'
import images from '../../Asset/Img/img';
import { useFormik } from 'formik';
// import emailjs from "emailjs-com";
import { useTranslation } from 'react-i18next';

import "./Form.css"

function Form() {

  const form = useRef()
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: {
      email: "",
      explanation: "",
      name: "",

    },
    onSubmit: (values) => {

      console.log(values);
      // emailjs.sendForm('service_r4our7c', 'template_64t4k1l', form.current, '5ANF71UTgiQQtr9ty')
      //   .then((result) => {
      //     console.log(result.text);

      //   }, (error) => {
      //     console.log(error.text);
      //   });

    }
  })



  
  return (
    <div className='form-container'>
      <h3>{t('footer-our-contact')}</h3>
      <form ref={form} className='form-container' onSubmit={formik.handleSubmit}>
        <input placeholder={t('footer-form-name')} type="name" id='name' name='name' onChange={formik.handleChange} value={formik.values.name} />
        <input placeholder={t('footer-form-email')} type="email" id='email' name='email' onChange={formik.handleChange} value={formik.values.email} />
        <textarea cols="40" rows="5" placeholder={t('footer-form-message')} id='explanation' name='explanation' onChange={formik.handleChange}></textarea>
        <button type='submit'><img src={images.sendIcon} alt="send-icon" />{t('footer-form-submit-button')}</button>
      </form>
    </div>
  )
}

export default Form